
import { Vue, Component, Provide, Inject } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import {
  IDomainsProviderData,
  IDomainsProviderMethods
} from "@/modules/web_hosting/models/domains";
import { IProvisionCategoriesProviderData } from "@/models/providers/provisioning";
import { IProvisionConfiguration } from "@/models/provisioning";
import { IProduct } from "@/models/products";

@Component
export default class DomainsProvider extends Vue {
  // Inject

  @Inject({ from: "provisionCategoriesProvider" })
  public readonly $provisionCategoriesData!: () => IProvisionCategoriesProviderData;

  public get categoriesData() {
    return this.$provisionCategoriesData();
  }

  // Methods

  public openManageTldModal(tld: IProduct | null = null) {
    if ((tld && !this.canUpdate) || (!tld && !this.canAddTld)) return;

    this.$store.dispatch(
      `data/${DataModules.HOST_MODULE_TLDS}/openManageTldModal`,
      {
        props: {
          ...(tld ? { tld } : {}),
          domainProviders: this.categoriesData.categoryProviders,
          domainCategoryId: tld
            ? tld.provision_category_id
            : this.categoriesData.provisionCategoryId
        },
        events: {
          success: () => {
            this.$bus.$emit("refreshTlds");
          }
        }
      }
    );
  }

  public async syncRenewalDates(
    configurationId: IProvisionConfiguration["id"]
  ) {
    try {
      const syncing = await this.$store.dispatch(
        `data/${DataModules.HOST_MODULE_TLDS}/syncRenewalDates`,
        { configurationId }
      );

      this.$store.dispatch("toast/show", {
        message: this.$t(
          "_modules.web_hosting.domains.sync_renewal_dates_successful",
          {
            count: syncing.sync_count
          }
        )
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  // Computed

  public get canAddTld() {
    return this.$userCan("web_hosting::create_tld_product");
  }

  // Computed

  public get canUpdate() {
    return this.$userCan("web_hosting::update_tld_product");
  }

  public get canSyncRenewalDate() {
    return this.$userCan(
      "web_hosting::sync_domain_registrar_configuration_due_dates"
    );
  }

  // Render

  public render() {
    return (
      this.$scopedSlots?.default &&
      this.$scopedSlots.default({
        $domainsData: this.providerData(),
        $domainsMethods: this.providerMethods
      })
    );
  }

  // Provide

  @Provide("domainsProviderData")
  public providerData(): IDomainsProviderData {
    return {
      canAddTld: this.canAddTld,
      canUpdate: this.canUpdate,
      canSyncRenewalDate: this.canSyncRenewalDate
    };
  }

  @Provide("domainsProviderMethods")
  public get providerMethods(): IDomainsProviderMethods {
    return {
      openManageTldModal: this.openManageTldModal,
      syncRenewalDates: this.syncRenewalDates
    };
  }
}
